import { render, staticRenderFns } from "./Easter.vue?vue&type=template&id=06c10ca4&scoped=true&"
import script from "./Easter.vue?vue&type=script&lang=js&"
export * from "./Easter.vue?vue&type=script&lang=js&"
import style0 from "./Easter.vue?vue&type=style&index=0&id=06c10ca4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c10ca4",
  null
  
)

export default component.exports